import { adapter } from '@flopflip/memory-adapter';

// Export a singleton instance of the memory adapter
// This ensures the same adapter instance is used throughout the app
export default adapter;
